import { render, staticRenderFns } from "./serviceProcess.vue?vue&type=template&id=20766991&scoped=true"
import script from "./serviceProcess.vue?vue&type=script&lang=js"
export * from "./serviceProcess.vue?vue&type=script&lang=js"
import style0 from "./serviceProcess.vue?vue&type=style&index=0&id=20766991&prod&lang=less&scoped=true"
import style1 from "./serviceProcess.vue?vue&type=style&index=1&id=20766991&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20766991",
  null
  
)

export default component.exports